<template>
  <TemplatePageGrid
    :items="workClientPersonGrid"
    :page-data="pageData"
    :loading="loadingAnimation"
    :page_params="{page: 'person_page', limit: 'person_limit'}"
  >
    <template v-slot:buttons>
      <WorkClientPersonModal
        v-if="$userCheckAccess({abilities: 'edit_client_people'})"
        create
      />
    </template>
    <WorkClientPersonTable :items="workClientPersonGrid" />
  </TemplatePageGrid>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkClientPersonTable from 'components/workClient/person/WorkClientPersonTable'
import WorkClientPersonModal from 'components/workClient/person/WorkClientPersonModal'

export default {
  name: 'WorkClientPerson',
  components: {
    WorkClientPersonTable,
    WorkClientPersonModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workClientPerson', ['workClientPersonGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workClientPerson', ['onWorkClientPersonGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.person_limit,
        page: this.$route.query.person_page,
        id: this.$route.params.id,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkClientPersonGrid(data)
    },
  },
}
</script>
